<div class="office__box"
     [attr.data-value]="delegation.provinces.length ? delegation.provinces[0].field : ''"
>

  <!-- Name -->
  <h3 *ngIf="delegation.title" class="office__box__name">{{ delegation.title }}</h3>

  <!-- Person in charge -->
  <p *ngIf="delegation.person" class="office__box__human">{{ delegation.person }}</p>

  <div class="office__data__module">

    <!-- Address -->
    <address *ngIf="delegation.address"
             class="office__data office__data--address"
             [innerHTML]="delegation.address"
    ></address>

    <!-- Telephones -->
    <div *ngIf="delegation.telephones?.values.length" class="office__data office__data--tel is--letter">
      <ng-container *ngFor="let tel of delegation.telephones.values">
        <a href="tel:{{ tel }}">{{ tel }}</a>
      </ng-container>
    </div>

    <!-- Faxes -->
    <div *ngIf="delegation.faxes?.values.length" class="office__data office__data--fax is--letter">
      <ng-container *ngFor="let fax of delegation.faxes.values">
        <a [href]="sanitize('fax:' + fax)">{{ fax }}</a>
      </ng-container>
    </div>

    <!-- Mobile phones -->
    <div *ngIf="delegation.mobilePhones?.values.length" class="office__data office__data--mobile is--letter">
      <ng-container *ngFor="let mobile of delegation.mobilePhones.values">
        <a href="tel:{{ mobile }}">{{ mobile }}</a>
      </ng-container>
    </div>

    <!-- Emails -->
    <div *ngIf="delegation.emails?.values.length" class="office__data office__data--email">
      <ng-container *ngFor="let email of delegation.emails.values">
        <a href="mailto:{{ email }}">{{ email }}</a>
      </ng-container>
    </div>

    <!-- Vcard -->
    <div *ngIf="delegation.vcard" class="office__data office__data--vcard">
      <a href="{{ delegation.vcard }}">{{ i18n["common.vcard"] }}</a>
    </div>

  </div>

</div>
